import WizardFooter from './WizardFooter';
import WizardHeader from './WizardHeader';
import WizardStepTitle from '../../Models/Layout/wizard/WizardStepTitle';
import { Box, Divider } from '@mui/material';
import { cardContainer } from '../../assets/styles/appStyles';

export default function Wizard({
  isSaving,
  saveLabel,
  onSaveClicked,
  onCancelClicked,

  children,
}: {
  isSaving:boolean;
  saveLabel?: string;
  onSaveClicked: () => void;
  onCancelClicked: () => void;
  children: any;
}) {
  return (
    <Box sx={cardContainer}>
      <Box p={2}>{children}</Box>
      <Divider />
      <WizardFooter
        isSaving={isSaving}
        saveLabel={saveLabel || 'Submit'}
        saveClicked={onSaveClicked}
        cancelClicked={onCancelClicked}
      />
    </Box>
  );
}
